














import { Component } from 'vue-property-decorator';
import VWrapper from '../../components/shared/VWrapper.vue';
import ImportForm from '../../components/shared/form/ImportForm.vue';
import { mixins } from 'vue-class-component';
import Editable from '@/mixins/Editable';
import Notification from '@/mixins/Notification';
import { namespace } from 'vuex-class';
import FoodcardApiService from '../../api/http/FoodcardApiService';
import { Venue } from '@/interfaces/models/Venue';

const venue = namespace('venue');

@Component({
  components: { ImportForm, VWrapper },
})
export default class ImportFoodcard extends mixins(Editable, Notification) {
  @venue.State('active') public venue!: Venue;

  public $refs!: {
    form: InstanceType<typeof ImportForm> & { getData: () => any; validate: () => Promise<boolean | boolean[]> };
  };

  public save() {
    this.$refs.form.validate().then(async (res: boolean) => {
      if (res) {
        const api: FoodcardApiService = new FoodcardApiService();
        const data: FormData = new FormData();
        data.append('file', this.$refs.form.getData().file);

        this.$startLoading('foodcard');
        await api.importFoodcard({ id: this.venue._id, file: data });
        this.$stopLoading('foodcard');
        this.$router.push({ name: 'article.index' });
      }
    });
  }
}
